"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Image_meta_1 = require("../Image.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('img', Image_meta_1.IMAGE_CATEGORY_KEY, Image_meta_1.IMAGE_COMPONENT_KEY, ['styledImage']);